import { Injectable } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { Observable } from 'rxjs';
import { RequestInfo, ResponseOptions, STATUS } from 'angular-in-memory-web-api';
import moment from 'moment';
import {
  RequiredEmployeesHourlyPredictionResponse,
  RequiredEmployeesPredictionResponse
} from '../../../interfaces/response/PredictionsResponses';

/**
 * This service intercepts {@link RequiredEmployeesPredictionService} requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root'
})
export class InMemoryEmployeesPredictionsDataService implements InMemoryHttpClient {

  /**
   * Intercepts HTTP DELETE request of {@link RequiredEmployeesPredictionService}.
   * @param reqInfo information about the current HTTP DELETE request.
   */
  delete(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP GET request of {@link RequiredEmployeesPredictionService}. Gets all required records from an in-memory data store.
   * @param reqInfo information about the current HTTP GET request.
   */
  get(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
        const fromDate = reqInfo.query.get('fromDate')[0];
        return {
          body: this.getEmployeePredictions(fromDate),
          status: STATUS.OK
        };
      }
    );
  }

  /**
   * Intercepts HTTP POST request of {@link RequiredEmployeesPredictionService}.
   * @param reqInfo information about the current HTTP POST request.
   */
  post(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PUT request of {@link RequiredEmployeesPredictionService}.
   * @param reqInfo information about the current HTTP PUT request.
   */
  put(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PATCH request of {@link RequiredEmployeesPredictionService}.
   * @param reqInfo information about the current HTTP PATCH request.
   */
  patch(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  private getEmployeePredictions(fromDate: string): RequiredEmployeesPredictionResponse[] {
    const fromDateMoment = moment(fromDate);
    const toDateMoment = moment(fromDate).add(7, 'day');
    const predictions: RequiredEmployeesPredictionResponse[] = [];
    for (let date = fromDateMoment; date <= toDateMoment; date = date.add(1, 'day')) {
      predictions.push({
        date: date.format('YYYY-MM-DD'),
        hourlyPredictions: this.getEmployeeHourlyPredictions()
      });
    }
    return predictions;
  }

  private getEmployeeHourlyPredictions(): RequiredEmployeesHourlyPredictionResponse[] {
    const hours = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    const hourlyPredictions: RequiredEmployeesHourlyPredictionResponse[] = [];

    hourlyPredictions.push({ hour: 7, prediction: 0 });
    hourlyPredictions.push({ hour: 8, prediction: 0 });
    hours.forEach((hour) => {
      hourlyPredictions.push({
        hour,
        prediction: this.randomIntFromInterval(0, 3)
      });
    });
    hourlyPredictions.push({ hour: 21, prediction: 0 });
    hourlyPredictions.push({ hour: 22, prediction: 0 });

    return hourlyPredictions;
  }

  private randomIntFromInterval(min: number, max: number) {
    return Math.random() * (max - min + 1) + min;
  }
}
